import React, { useEffect, useState } from 'react';
import { CheckCircleIcon, ChatBubbleLeftRightIcon } from '@heroicons/react/24/outline';
import toast from 'react-hot-toast';
import {
	getTelegramLinkStatus,
	unlinkTelegram,
} from '../../services/accountTelegramService';
import { TelegramLinkModal } from './TelegramLinkModal';

/**
 * Карточка в настройках рекрутера для привязки Telegram-бота нотификаций
 * (TASKNEIROKLYUCH-647 Bot API доработка).
 *
 * Состояния:
 *   - loading → спиннер
 *   - not linked → кнопка «Подключить Telegram» → открывает модалку
 *   - linked → «✓ Подключено» + кнопка «Отвязать»
 */
export const TelegramNotificationCard: React.FC = () => {
	const [linked, setLinked] = useState<boolean | null>(null);
	const [modalOpen, setModalOpen] = useState(false);
	const [unlinking, setUnlinking] = useState(false);

	useEffect(() => {
		refreshStatus();
	}, []);

	const refreshStatus = async () => {
		try {
			const status = await getTelegramLinkStatus();
			setLinked(status.linked);
		} catch {
			setLinked(false);
		}
	};

	const handleUnlink = async () => {
		if (!window.confirm('Отвязать Telegram? Нотификации перестанут приходить в бота.')) {
			return;
		}
		setUnlinking(true);
		try {
			await unlinkTelegram();
			setLinked(false);
			toast.success('Telegram отвязан');
		} catch {
			toast.error('Не удалось отвязать. Попробуйте ещё раз.');
		} finally {
			setUnlinking(false);
		}
	};

	return (
		<div className="border border-gray-200 rounded-lg p-4 bg-white">
			<div className="flex items-start gap-3">
				<ChatBubbleLeftRightIcon className="w-6 h-6 text-[#0088cc] flex-shrink-0 mt-1" />
				<div className="flex-1">
					<h3 className="font-medium text-gray-900">Telegram для нотификаций</h3>
					<p className="text-sm text-gray-600 mt-1">
						Получайте уведомления о критичных событиях (эскалация, одобрение кандидата, интервью, скрининг) в Telegram через официального бота.
					</p>

					<div className="mt-4">
						{linked === null && (
							<div className="animate-spin rounded-full h-4 w-4 border-b-2 border-gray-400" />
						)}

						{linked === true && (
							<div className="flex items-center gap-3">
								<span className="inline-flex items-center gap-1.5 text-sm text-green-700 font-medium">
									<CheckCircleIcon className="w-5 h-5" />
									Подключено
								</span>
								<button
									onClick={handleUnlink}
									disabled={unlinking}
									className="text-sm text-red-600 hover:text-red-700 disabled:opacity-50"
								>
									{unlinking ? 'Отвязываем...' : 'Отвязать'}
								</button>
							</div>
						)}

						{linked === false && (
							<button
								onClick={() => setModalOpen(true)}
								className="bg-[#0088cc] text-white py-2 px-4 rounded-md hover:bg-[#0077b3] transition text-sm"
							>
								Подключить Telegram
							</button>
						)}
					</div>
				</div>
			</div>

			<TelegramLinkModal
				open={modalOpen}
				onOpenChange={setModalOpen}
				onLinked={refreshStatus}
			/>
		</div>
	);
};
